import { z } from 'zod';

export const MeSchema = z.object({
  userId: z.number(),
  /** The id knowledge base folders expose as `createdBy` / `owner.userUuid`. */
  userUuid: z.string().nullish(),
  clientId: z.number(),
  isAdminUser: z.boolean(),
});
